export default {
  'refundDetails.refundStatus.PENDING_APPROVAL': 'Pending approval',
  'refundDetails.refundStatus.CREATED': 'Created',
  'refundDetails.refundStatus.FAILED': 'Failed',
  'refundDetails.refundStatus.PROCESSED': 'Processing',
  'refundDetails.refundStatus.COMPLETED': 'Completed',
  'refundDetails.refundStatus.REJECTED': 'Rejected',
};
